import { createClient } from '@supabase/supabase-js';

// Create React App requires REACT_APP_ prefix for environment variables
// These must be set in Netlify's environment variables BEFORE building
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Validate environment variables
if (!supabaseUrl || !supabaseAnonKey) {
  const missingVars = [];
  if (!supabaseUrl) missingVars.push('REACT_APP_SUPABASE_URL');
  if (!supabaseAnonKey) missingVars.push('REACT_APP_SUPABASE_ANON_KEY');
  
  const errorMessage = `Missing required Supabase environment variables: ${missingVars.join(', ')}.\n` +
    `Please configure these in Netlify:\n` +
    `1. Go to Site settings → Build & deploy → Environment → Environment variables\n` +
    `2. Add: REACT_APP_SUPABASE_URL (your Supabase project URL)\n` +
    `3. Add: REACT_APP_SUPABASE_ANON_KEY (your Supabase anon/public key)\n` +
    `4. Trigger a new build after adding the variables.`;
  
  console.error('❌', errorMessage);
  
  // In production, throw error to prevent silent failures
  if (process.env.NODE_ENV === 'production') {
    throw new Error(errorMessage);
  }
}

// Create Supabase client with validated credentials
export const supabase = createClient(
  supabaseUrl || '',
  supabaseAnonKey || '',
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    },
  }
);

export default supabase;
